import Heading5 from './Heading5'
export default Heading5
